import React from "react";
import { Container, Row, Col, Card, CardHeader, Button, Input, ListGroup, ListGroupItem, Label } from "@/Components/ui";;
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import { API_NOTIFICATION, getDataFromUrl } from "../../../api";
import ServerPaginatedTable from "../../../Components/Common/ServerPaginatedTable";
import { Link } from "react-router-dom";
import moment from "moment";

const NotificationList = () => {
  const [data, setData] = React.useState([]);
  const [previous, setPrevious] = React.useState("");
  const [next, setNext] = React.useState("");
  const [count, setCount] = React.useState("");

  const onRequestData = (_url) => {
    getDataFromUrl(_url)
      .then((data) => {
        setData(data.results);
        setPrevious(data.previous);
        setNext(data.next);
        setCount(data.count);
        // if (isSearch) calcTotalPageCount(data.count, (data.results).length);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  React.useEffect(() => {
    if (!previous && !next) {
      getDataFromUrl(`${API_NOTIFICATION}`)
        .then((data) => {
          // console.log(data);
          setData(data.results);
          setPrevious(data.previous);
          setNext(data.next);
          setCount(data.count);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, []);

  const columns = React.useMemo(
    () => [
      // {
      //   Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
      //   Cell: (cellProps) => {
      //     return <input type="checkbox" className="customerCheckBox form-check-input" value={cellProps.row.original.id} />;
      //   },
      //   id: "#",
      // },
      {
        Header: 'ID',
        accessor: 'id',
        id: 'id',
      },
      {
        Header: "이름",
        accessor: "username",
        id: "username",
        // Cell: (cellProps) => {
        //   return (
        //     <Link to={`/user/${cellProps.row.original.id}`} className="link">
        //       <span>{cellProps.row.original["이름"]}</span>
        //     </Link>
        //   );
        //   // return <a href={`/user/${cellProps.row.original.id}`} className="stretched-link"><span>{cellProps.row.original['이름']}</span></a>
        // },
      },
      {
        Header: "전화번호",
        accessor: "phone_num",
        id: "phone_num",
        // Cell: (cellProps) => {
        //   return (
        //     <Link to={`/user/${cellProps.row.original.id}`} className="link">
        //       <span>{cellProps.row.original["전화번호"]}</span>
        //     </Link>
        //   );
        // },
      },
      {
        Header: 'title',
        accessor: 'title',
        id: 'title',
      },
      {
        Header: 'message',
        accessor: 'message',
        id: 'message',
      },
      {
        Header: 'data',
        accessor: 'data',
        id: 'data',
        Cell: (cellProps) => {
          const _data = cellProps.row.original.data;
          if (!_data) return null;
          return <span>{_data.url}</span>;
        }
      },
      {
        Header: 'state',
        accessor: 'state',
        id: 'state',
      },
      {
        Header: "push_at",
        accessor: "push_at",
        id: "push_at",
        Cell: (cellProps) => {
          if (!cellProps.row.original.push_at) return null;
          return <span>{moment(cellProps.row.original.push_at).format("YYYY-MM-DD HH:mm:ss")}</span>;
        },
      },
      {
        Header: 'read_at',
        accessor: 'read_at',
        id: 'read_at',
        Cell: (cellProps) => {
          if (!cellProps.row.original.read_at) return null;
          return <span>{moment(cellProps.row.original.read_at).format("YYYY-MM-DD HH:mm:ss")}</span>;
        },
      },
    ],
    []
  );


  // const clearSelectedOptions = () => {
  //   setSelectedCoupon(0);
  //   setSelectedVoucher(0);
  //   setVoucherCount(0);
  //   setIsSend(false);
  //   setIsBatch(false);
  //   setHasToReceive(false);
  // };

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".customerCheckBox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="알림관리" pageTitle="알림" />
          <Row>
            <Col lg={12}>
              <Card id="customerList">
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">알림 목록</h5>
                      </div>
                    </div>
                    <div className="col-sm-auto">
                      <div>

                      </div>
                    </div>
                  </Row>
                </CardHeader>

                <div className="card-body pt-0 px-2">
                  <div>
                    <React.Fragment>
                      <ServerPaginatedTable url={API_NOTIFICATION} columns={columns} data={data} previous={previous} next={next} count={count} onRequestData={onRequestData} categories={[]} />
                    </React.Fragment>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

    </React.Fragment>
  );
};

export default NotificationList;
